export default __webpack_public_path__ + "static/media/warranty_banner_mobile.b7fa0083.png";